
define('text!editor/edit/layers/edit/legend.html',[],function () { return '<div id="legend-editor" data-bind="compose: content"></div>';});

